<template>
    <div id="pagesync">
        <h2>{{ trans('pages.sync.orders.title') }}</h2>

        <div
            class="syncline"
            data-url="/order/autoprocessOrders/"
        >
            <img
                class="syncicon"
                alt="import"
                src="images/import.png"
            />
            <div class="synclabel">
                {{ trans('pages.sync.orders.process_automatically') }}
            </div>
            <div class="syncstatus">
                <spinner
                    width="16"
                    height="16"
                />
            </div>
            <ui5-button class="syncbutton">
                {{ trans('pages.sync.sync_button') }}
            </ui5-button>
        </div>

        <h2>{{ trans('pages.sync.others.title') }}</h2>

        <div
            class="syncline"
            data-url="/product/calculatePowderToOrder/"
        >
            <img
                class="syncicon"
                alt="import"
                src="images/import.png"
            />
            <div class="synclabel">
                {{ trans('pages.sync.others.calculate_powder') }}
            </div>
            <div class="syncstatus">
                <spinner
                    width="16"
                    height="16"
                />
            </div>
            <ui5-button class="syncbutton">
                {{ trans('pages.sync.sync_button') }}
            </ui5-button>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Spinner from '../components/loader/Spinner';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { Spinner },
    mixins: [localization],
    mounted() {
        //Converting JQuery to vanilla JS as practice

        this.$el.querySelectorAll('.syncline[data-url]').forEach((syncline) => {
            const syncButton = syncline.querySelector('.syncbutton');

            syncButton.addEventListener('click', () => {
                const status = syncline.querySelector('.syncstatus');
                const statusImg = status.querySelector('img');
                const url = syncline.getAttribute('data-url');
                syncButton.disabled = true;
                status.style.display = 'block';
                statusImg.setAttribute('src', 'images/ajax-loader.gif');

                axios
                    .post(url)
                    .then(() => {
                        statusImg.setAttribute('src', 'images/done.png');
                    })
                    .catch(() => {
                        statusImg.setAttribute('src', 'images/error.png');
                        showErrorMessage(
                            this.trans('pages.sync.error_message')
                        );
                    })
                    .finally(() => {
                        syncButton.disabled = false;
                    });
            });
        });

        this.$el.querySelectorAll('.syncstatus').forEach((status) => {
            status.style.display = 'none';
        });
    },
};
</script>
